export * from './patentViewer';
